import React, { useRef, useState } from 'react';
import { useEffect } from 'react';
import useMedia from '../../../../hooks/useMedia';
import FilterBody from './FilterBody';
import './filters.scss';

const Filters = props => {
    const {
        modalIsOpen,
        setModalIsOpen,
        data,
        setFilterData,
        filterData,
        title,
        filterTitleClass,
        filterBodyClasess,
        toggleSelect,
        showMoreLimit,
        isShowMoreVisible,
        onShowMoreClick,
        clearAll,
        setIsClearAll,
        resultQty,
        triggerEvents
    } = props;
    const [filterModalOpen, setFilterModalOpen] = useState(false);
    const [isSticky, setIsSticky] = useState(false);

    const mediaType = useMedia();
    const customStyle = { overlay: { background: 'rgba(0,0,0,0.4)' }, content: { padding: '0px' } };
    const mobileFilterRef = useRef(null);

    const handleIsSticky = e => {
        const scrollTop = mobileFilterRef.current.scrollTop;
        scrollTop >= 10 ? setIsSticky(true) : setIsSticky(false);
    };

    useEffect(() => {
        if (filterModalOpen) {
            mobileFilterRef.current?.addEventListener('scroll', handleIsSticky);
        } else {
            mobileFilterRef.current?.removeEventListener('scroll', handleIsSticky);
        }
    }, [filterModalOpen]);

    const afterOpenModal = () => {
        setFilterModalOpen(!filterModalOpen);
    };

    useEffect(() => {
        const body = document.querySelector('body');
        if (modalIsOpen) {
            body.classList.add('overflow-hidden');
        } else body.classList.remove('overflow-hidden');
    }, [modalIsOpen]);

    const handleModalClose = () => {
        setModalIsOpen(!modalIsOpen);
    };
    return (
        <FilterBody
            filterBodyClasess={filterBodyClasess}
            data={data}
            filterData={filterData}
            setFilterData={setFilterData}
            toggleSelect={toggleSelect}
            setIsClearAll={setIsClearAll}
            clearAll={clearAll}
            isShowMoreVisible={isShowMoreVisible}
            onShowMoreClick={onShowMoreClick}
            triggerEvents={triggerEvents}
        />
    );
};

export default Filters;
